<template>
  <div>
    <div class="title">
      <div id="notice">
        <h5>冲撞仪信息登记使用说明:<br>
          <span>1、直接录入即可</span><br>
          <span>2、状态:只有提交状态可以使用,其他状态不可以</span><br>
          <span>3、查询关键字:型号</span><br>
        </h5>
      </div>
    </div>

    <pre-base ref="mybase" @base2-event="refresh_father" :pre_data="init_data">

    </pre-base>

  </div>
</template>

<script>
	
  export default {
    components: {
      "pre-base": () => import("../auto/auto_view_easy.vue")
    },
    data() {
      return {
        init_data: '',
        row_id: '',
        item: ''
      };
    },
    mounted: function() {
      var that = this;
      this.$nextTick(function() {
        that.fun_init();
      });
    },
    methods: {
      fun_init:  function() {

        this.init_data = '';
        this.init_data = JSON.stringify({
          "title": '冲撞仪信息',
          "control": "bumpinfo",
          "isTwo": "1",
          "isTwoDetail":"1",
          "action_flag": "",
          "isFileMain":"1",
          "step":"0",
          "sel_action": 'exp_ys_bump_info',
          "upd_action": 'exp15_ys_bump_info',
          "detail_part":"0",
          "d_sel_action": '',
          "d_upd_action": '',
          "file_action": 'bumpinfo',
          "p1": 'trans',
          "p2": 'bump',
          "p3": '',
          "parm_sel": [
            {
              "name": "型号",
              "val": "",
              "key": "bump_name",
              "type": "text",
              "class": "long1",
              "sel": "1"
            }
          ],
          "parm": [
			  {
              "name": "型号",
              "val": "",
              "key": "bump_name",
              "type": "text",
              "class": "long2",
              "p": "1",
              "w": "0",
              "r": "0",
              "x":"1"
            },
            {
              "name": "购买金额",
              "val": "",
              "key": "buy_price",
              "type": "number",
              "class": "long1",
              "p": "1",
              "w": "0",
              "r": "0",
              "x": "1"
            },
            {
              "name": "购买日期",
              "val": "",
              "key": "buy_date",
              "type": "date",
              "class": "long1",
              "p": "1",
              "w": "0",
              "r": "0",
              "x": "1"
            },
            {
              "name": "备注",
              "val": "",
              "key": "note",
              "type": "text",
              "class": "long2",
              "p": "1",
              "w": "0",
              "r": "0"
            }
          ],
          "parm_th": [{
              "name": "序号"
            }, {
              "name": "型号"
            },
            {
              "name": "购买金额"
            },
            {
              "name": "购买日期"
            },
            {
              "name": "备注",
              "class":"long2"
            },
            {
              "name": "附件"
            },
            {
              "name": "状态",
              "class":"short0"
            },
            {
              "name": "修改人",
              "class":"short0"
            },
            {
              "name": "路径1"
            },
            {
              "name": "路径2"
            },
            {
              "name": "修改时间",
              "class":"long2"
            }
          ],
          "d_parm": [
          ],
          "d_name": [
          ]

        });
      },
      refresh_data: function(type) {
        var that = this;
        this.$nextTick(function() {
          that.$refs['mybase'].refresh_data(type);
        });
      },
      refresh_father: function(type, val, parm) {
        // console.log('type=' + type + ' val=' + val);
        switch (type) {
          case 'father':
            // 弹出修改明细，修改主窗口信息
            this.refresh_data();
            break;
         default:
            // console.log('子组件刷新父组件传值=' + val);
            this.row_id = val;
            this.item = parm;
            break;
        }
      }
	  


    }
  };
</script>
<style scoped>
  /* 设置 倒数 第二、第三列 隐藏 */
  .path_none>td:nth-last-child(3),
  .path_none>td:nth-last-child(2) {
    display: none;
  }
</style>
